// Copyright (c) billwerk GmbH. All rights reserved.
'use strict';

var ContractPauseController = function (
    $scope, $routeParams, $location, $http, Contract, ProductInfo, ContractCancellationPreview, ContractTimeDetails,
    PUtill, gettextCatalog, gettext, ContractPauseService, DatepickerUtils) {
    
    const pauseStartEnum = Object.freeze({
        "Immediately": "Immediately",
        "AfterCurrentPeriod": "AfterCurrentPeriod"
    });
    
    $scope.pauseContractData = { StartDate : null, EndDate : null };
    $scope.saveClicked = false;
    $scope.pauseStart = pauseStartEnum.Immediately;
    $scope.creditAmount = 0;
    
    $scope.changeStart = function () {
        $scope.pauseContractData.StartDate = $scope.pauseStart === pauseStartEnum.Immediately ? null : new Date($scope.billedUntil);
        ContractPauseService.pausePreview($routeParams.contractId, $scope.pauseContractData)
            .then(function (response) {
                $scope.creditAmount = -response.data.Invoice.TotalGross;
            });
    }
    
    ContractTimeDetails.get({ contractId: $routeParams.contractId }, function (cont) {
        $scope.billedUntil = cont.BilledUntil || cont.NextBillingDate;
    });

    $scope.changeStart();

    $scope.$watch("pauseContractData.EndDate", function (newValue, oldValue) {
        if (!PUtill.areDatesEqual(newValue, oldValue) && newValue) {
            $scope.changeStart();
        }
    });
   
    let productInfo = ProductInfo.get(function () {
        $scope.contract = Contract.get({ contractId: $routeParams.contractId }, function () {
            $scope.plan = productInfo.PlanById($scope.contract.PlanId);
            $scope.planGroup = productInfo.PlanGroupById($scope.plan.PlanGroupId);
            
            let planVariant = productInfo.PlanVariantById($scope.contract.PlanVariantId);
            let periodEnd = $scope.contract.CurrentPhase.Type === 'Trial' ? planVariant.ContractPeriod : planVariant.LaterContractPeriod;
            $scope.contractPeriodEnd = PUtill.addPeriod(periodEnd, $scope.contract.CurrentPhase.StartDate);
        });
    });

    $scope.isPauseOverlapping = function () {
        return !$scope.contract.Pauses.every(function (existingPause) {
            let newPause = $scope.pauseContractData;
            let existingPauseStartDate = new Date(existingPause.StartDate);
            let existingPauseEndDate = existingPause.EndDate !== undefined ? new Date(existingPause.EndDate) : null;
            let newPauseStartDate = newPause.StartDate ?? new Date();
            let newPauseEndDate = newPause.EndDate !== null ? DatepickerUtils.backToBrowserTimezone(newPause.EndDate) : null;

            let isOverlap =
                (newPauseStartDate >= existingPauseStartDate && (existingPauseEndDate === null || newPauseStartDate < existingPauseEndDate))
                || (existingPauseStartDate >= newPauseStartDate && (newPauseEndDate === null || existingPauseStartDate < newPauseEndDate));
            return !isOverlap;
        });
    };
    
    $scope.pauseContract = function () {
        function internalPauseContract() {
            $scope.saveClicked = true;
            ContractPauseService.pause($routeParams.contractId, $scope.pauseContractData).then(function () {
                $location.path("/contracts/" + $routeParams.contractId);
            }, function () {
                $scope.saveClicked = false;
            });
        }
        
        if ($scope.saveClicked)
            return;

        if($scope.isPauseOverlapping()){
             $scope.yesCancel(gettextCatalog.getString(gettext('Pause contract')),
                 gettextCatalog.getString(gettext('The configured pause overlaps with existing pause periods.\nAre you sure you want to continue?')),
                 internalPauseContract
             );
         }
         else 
             internalPauseContract();
    };
};
    
ContractPauseController.$inject = [
    '$scope', '$routeParams', '$location', '$http', 'Contract', 'ProductInfo', 'ContractCancellationPreview', 
    'ContractTimeDetails', 'PUtill', 'gettextCatalog', 'gettext', 'ContractPauseService', 'DatepickerUtils'];
